module.exports = __webpack_public_path__ + "img/Colorization4.ded9fbab.webp";